import React, { createContext, useEffect, useState } from "react";
import axios from "../Axios/Axios";
import { Urls } from "../Urls";
import { auth } from "../Components/firebase/firebase";

export const EditableEmailsContext = createContext({});

export const EditableEmailsProvider = ({ children }) => {
    const [emailData, setEmailData] = useState({});

    useEffect(() => {
        if (auth && auth.currentUser && auth.currentUser.getIdToken()) {
            var payload = {
                "template_id_list": ["email_1", "email_2", "email_5", "email_6", "email_7", "email_8",
                    "email_9", "email_10", "email_27", "email_33", "email_34", "email_35", "email_36", "email_37", "email_38",
                    "email_39", "email_40", "email_41", "email_42", "email_49", "email_50",
                    "email_62", "email_73", "email_74", "email_91", "email_103", "email_104", "email_138", "email_139"
                ]
            }
            axios.post(`${Urls.email_template}?template_id_list=true`, payload)
                .then((res) => {
                    // console.log(res.data, 'email context')
                    const mapEmailTemplates = (templates) => {
                        const mappedData = {};
                        templates.map(template => {
                            switch (template.template_id) {
                                case 'email_1':
                                    mappedData.clientReceivesEnquiryMail = template;
                                    break;
                                case 'email_2':
                                    mappedData.transporterReceivesEnquiryMail = template;
                                    break;
                                case 'email_5':
                                    mappedData.transporterReceivesAcceptingMail = template;
                                    break;
                                case 'email_6':
                                    mappedData.clientReceivesAcceptingMail = template;
                                    break;
                                case 'email_7':
                                    mappedData.transporterReceivesRejectionMail = template;
                                    break;
                                case 'email_8':
                                    mappedData.clientReceivesRejectionMail = template;
                                    break;
                                case 'email_9':
                                    mappedData.transporterReceivesCounterMail = template;
                                    break;
                                case 'email_10':
                                    mappedData.clientReceivesCounterMail = template;
                                    break;
                                case 'email_27':
                                    mappedData.clientReceivesApprovalLaneRequestMail = template;
                                    break;
                                case 'email_33':
                                    mappedData.clientReceivesIndentMail = template;
                                    break;
                                case 'email_34':
                                    mappedData.transporterReceivesIndentMail = template;
                                    break;
                                case 'email_35':
                                    mappedData.clientReceivesIndentEditMail = template;
                                    break;
                                case 'email_36':
                                    mappedData.transporterReceivesIndentEditMail = template;
                                    break;
                                case 'email_37':
                                    mappedData.clientReceivesIndentCancelMail = template;
                                    break;
                                case 'email_38':
                                    mappedData.transporterReceivesIndentCancelMail = template;
                                    break;
                                case 'email_39':
                                    mappedData.clientReceivesTruckAllocationMail = template;
                                    break;
                                case 'email_40':
                                    mappedData.transporterReceivesTruckAllocationMail = template;
                                    break;
                                case 'email_41':
                                    mappedData.clientReceivesPmMail = template;
                                    break;
                                case 'email_42':
                                    mappedData.transporterReceivesPmMail = template;
                                    break;
                                case 'email_49':
                                    mappedData.transporterReceivesReminderMail = template;
                                    break;
                                case 'email_50':
                                    mappedData.clientReceivesReminderMail = template;
                                    break;
                                case 'email_62':
                                    mappedData.auctionControllerMail = template
                                    break;
                                case 'email_73':
                                    mappedData.indentTrackMail = template
                                    break;
                                case 'email_74':
                                    mappedData.notifyEmailForInvoiceDetails = template
                                    break;
                                case 'email_91':
                                    mappedData.notifyEmailForMastersUpdate = template
                                    break;
                                case 'email_103':
                                    mappedData.clientReceivesSignupMail = template
                                    break;
                                case 'email_104':
                                    mappedData.superUserReceivesNewUserMail = template
                                    break;
                                case 'email_138':
                                    mappedData.internalNewUserSignupMail = template
                                    break;
                                case 'email_139':
                                    mappedData.benchmarkAlertMail = template
                                    break;
                                default:
                                    // Handle default case if needed
                                    break;
                            }
                        });

                        // console.log(mappedData, "mapped data")
                        return mappedData;
                    };

                    // Usage
                    const emailTemplatesMap = mapEmailTemplates(res.data);
                    setEmailData(emailTemplatesMap);
                })
        }
    }, []);

    return (
        <EditableEmailsContext.Provider value={emailData}>
            {children}
        </EditableEmailsContext.Provider>
    );
};